var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#2E343D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2383 8.15234C12.3359 8.23047 12.3359 8.38672 12.2383 8.48438L8.15625 12.5664C8.05859 12.6641 7.92188 12.6641 7.82422 12.5664L3.74219 8.48438C3.64453 8.38672 3.64453 8.23047 3.74219 8.15234L4.11328 7.76172C4.21094 7.66406 4.36719 7.66406 4.44531 7.76172L7.49219 10.7891V4.10938C7.49219 3.99219 7.58984 3.875 7.72656 3.875H8.27344C8.39062 3.875 8.50781 3.99219 8.50781 4.10938V10.7891L11.5352 7.76172C11.6133 7.66406 11.7695 7.66406 11.8672 7.76172L12.2383 8.15234Z",
    fill: "#FA0B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDownArrow);
export default __webpack_public_path__ + "static/media/redDownArrow.9d85fb538edfc555c382473a710a180b.svg";
export { ForwardRef as ReactComponent };